<template>
  <div class="app-container" style="height: calc(100vh - 160px); overflow-y: auto">
    <div v-if="customerType.type !== 'examine'" style="margin-bottom: 10px; float: right">
      <div>
        <el-button
          icon="el-icon-plus" plain size="small"
          @click="clickAddData"
        >
          {{ $t('GlobalSetObj.create') }}
        </el-button>
        <el-button
          icon="el-icon-plus"
          size="small"
          type="primary"
          @click="clickSenderDialog($t('customerManagements.createSender'), null)"
        >
          {{ $t('navbar.orderImport') }}
        </el-button>
      </div>
    </div>
    <div>
      <el-form
        ref="addFormRef"
        :inline="false"
        :model="newFormInline"
        class="demo-ruleForm"
        label-position="top"
        size="mini"
      >
        <el-table
          :data="newFormInline.skuList"
          :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
          border
          height="670"
          style="width: 100%"
        >
          <el-table-column :label="$t('GlobalSetObj.serial')" type="index" width="70" />
          <el-table-column
            :label="$t('uploadFile.skuSystemCode')"
            min-width="120"
            prop="skuSystemCode"
          />
          <el-table-column min-width="140" prop="productName">
            <template v-slot:header>
              <div>
                <span style="color: #f00">*</span>
                {{ $t('uploadFile.productName') }}
              </div>
            </template>
            <template #default="scope">
              <div class="flx-center">
                <div v-if="scope.row.isEdit === false">
                  {{ scope.row.productName }}
                </div>
                <el-form-item
                  v-else
                  :prop="'skuList.' + scope.$index + '.productName'"
                  :rules="[
                    {
                      required: true,
                      message: $t('GlobalSetObj.pleaseInput'),
                      trigger: ['change', 'blur']
                    }
                  ]"
                >
                  <el-input
                    v-model="scope.row.productName"
                    :maxlength="500"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                    show-word-limit
                  />
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="150" prop="skuCode">
            <template v-slot:header>
              <div>
                <span style="color: #f00">*</span>
                {{ $t('uploadFile.productSkuCode') }}
              </div>
            </template>
            <template #default="scope">
              <div class="flx-center">
                <div v-if="scope.row.isEdit === false">
                  {{ scope.row.skuCode }}
                </div>
                <el-form-item
                  v-else
                  :prop="'skuList.' + scope.$index + '.skuCode'"
                  :rules="[
                    {
                      required: true,
                      message: $t('GlobalSetObj.pleaseInput'),
                      trigger: ['change', 'blur']
                    }
                  ]"
                >
                  <el-input
                    v-model="scope.row.skuCode"
                    :maxlength="50"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                    show-word-limit
                  />
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" prop="dimension">
            <template v-slot:header>
              <div>
                <span style="color: #f00">*</span>
                {{ $t('uploadFile.appearanceDimensions') }}
              </div>
            </template>
            <template #default="scope">
              <div class="flx-center">
                <div v-if="scope.row.isEdit === false">
                  {{ scope.row.dimension }}
                </div>
                <el-form-item
                  v-else
                  :prop="'skuList.' + scope.$index + '.dimension'"
                  :rules="dimensionVeriy"
                >
                  <el-input
                    v-model="scope.row.dimension"
                    :maxlength="8"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                  />
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" prop="grossWeight">
            <template v-slot:header>
              <div>
                <span style="color: #f00">*</span>
                {{ $t('uploadFile.grossWeight') }}
              </div>
            </template>
            <template #default="scope">
              <div class="flx-center">
                <div v-if="scope.row.isEdit === false">
                  {{ scope.row.grossWeight }}
                </div>
                <el-form-item
                  v-else
                  :prop="'skuList.' + scope.$index + '.grossWeight'"
                  :rules="weightVeriy"
                >
                  <el-input
                    v-model="scope.row.grossWeight"
                    :maxlength="8"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                  />
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" prop="status">
            <template v-slot:header>
              <div>
                <span style="color: #f00">*</span>
                {{ $t('GlobalSetObj.status') }}
              </div>
            </template>
            <template #default="scope">
              <div class="flx-center">
                <div v-if="scope.row.isEdit === false">
                  {{ scope.row.status ? $t('GlobalSetObj.enable') : $t('GlobalSetObj.stop') }}
                </div>
                <el-form-item
                  v-else
                  :prop="'skuList.' + scope.$index + '.status'"
                  :rules="[
                    {
                      required: true,
                      message: $t('GlobalSetObj.pleaseInput'),
                      trigger: ['change', 'blur']
                    }
                  ]"
                >
                  <el-select v-model="scope.row.status">
                    <el-option :label="$t('GlobalSetObj.enable')" :value="1" />
                    <el-option :label="$t('GlobalSetObj.stop')" :value="0" />
                  </el-select>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('GlobalSetObj.CreationTime')"
            min-width="120"
            prop="createTime"
          />
          <el-table-column
            :label="$t('GlobalSetObj.CreatePeople')"
            min-width="120"
            prop="createUserName"
          />
          <el-table-column
            :label="$t('GlobalSetObj.LastModified')"
            min-width="120"
            prop="updateTime"
          />
          <el-table-column
            :label="$t('GlobalSetObj.editor')"
            min-width="120"
            prop="updateUserName"
          />
          <el-table-column
            v-if="customerType.type !== 'examine'"
            :label="$t('GlobalSetObj.operate')"
            align="center"
            fixed="right"
            width="100"
          >
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.isEdit === false" class="flx-around">
                  <span
                    class="iconfont icon-a-ziyuan37 editOperation"
                    @click="editSku(scope.row)"
                  />
                </div>
                <div v-else-if="scope.row.isDel === true" class="flx-around">
                  <span class="iconfont icon-a-ziyuan54 delOperation" @click="delSku(scope.row)" />
                </div>
                <div v-else>
                  <span v-if="scope.row.isEditNew === false" />
                  <div v-else class="flx-around">
                    <span
                      class="iconfont icon-chenggong cancalOperation"
                      @click="saveOneSku(scope, scope.row.id)"
                    />
                    <span class="iconfont icon-a-ziyuan40 delOperation" @click="cancelSku(scope)" />
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div class="flx-end" style="margin-top: 15px">
        <!--  分页  -->
        <el-pagination
          :current-page="queryForm.pageNumber"
          :page-size="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="queryForm.total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin-right: 15px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
        <div v-if="customerType.type !== 'examine'">
          <el-button size="small" type="primary" @click="clickSubmit">
            {{ $t('uploadFile.submit') }}
          </el-button>
          <el-button plain size="small" @click="resetForm">
            {{ $t('customerManagements.reset') }}
          </el-button>
        </div>
      </div>
    </div>
    <!-- 新增客户视角 -->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :title="$t('navbar.orderImport')"
      :visible.sync="exportDialog"
      width="550px"
      @close="handleClose"
    >
      <div>
        <div style="font-weight: bold; font-size: 18px; margin-bottom: 10px">
          {{ $t('uploadFile.uploadSkuInfoFile') }}
        </div>
        <div class="flx-center">
          <el-upload
            :before-upload="beforeUpload"
            :file-list="fileList"
            :headers="{
              'Content-Type': 'multipart/form-data'
            }"
            :http-request="handleHttpRequest"
            :limit="1"
            :on-remove="handleRemove"
            accept=".csv,.xlsx"
            action="#"
            class="upload-demo"
            drag
          >
            <i class="el-icon-upload" />
            <div class="el-upload__text">{{ $t('uploadFile.dragOrClickToUpload') }}</div>
          </el-upload>
        </div>
        <div style="font-weight: bold; font-size: 16px; margin: 10px">
          {{ $t('uploadFile.skuTemplateDownload') }}
        </div>
        <div class="downModule flx-between" @click="downLoadFile">
          <div>{{ $t('orderCenterCont.DownloadTemplate') }}</div>
          <div><i class="el-icon-download" /></div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cusSubmit(1)">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button
          size="small" type="primary" @click="cusSubmit(2)"
        >{{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  customerSkuInfoAdd,
  customerSkuInfoEdit,
  customerSkuInfoImport,
  customerSkuInfoPage
} from '@/api/newExpressAPI';
import { saveAs } from 'file-saver';
import { dimensionVerification, weightVerification } from '@/utils/validate';

export default {
  name: 'SkuInfo',
  props: {
    // 客户ID
    customerId: {
      type: [Number, String],
      default: ''
    },
    customerType: {
      type: Object,
      default() {
        return {
          id: '',
          type: 'add'
        };
      }
    }
  },
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0
      },
      newFormInline: {
        skuList: []
      },
      skuListAdd: [],
      recordsList: [],
      editId: '',
      exportDialog: false,
      fileName: '',
      fileData: null,
      // 外观尺寸验证
      dimensionVeriy: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        { validator: dimensionVerification, trigger: ['blur', 'change'] }
      ],
      weightVeriy: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        { validator: weightVerification, trigger: ['blur', 'change'] }
      ],
      fileList: [],
      deleteFlag: 1
    };
  },
  created() {
    this.getSearch();
  },
  methods: {
    // 上传前
    beforeUpload() {},
    handleRemove() {
      this.fileName = '';
      this.fileData = null;
      this.sizeFile = '';
    },
    handleHttpRequest(options) {
      console.log(options, 'handleHttpRequest');
      this.fileData = options.file;
      this.fileName = options.file.name;
      this.sizeFile = options.file.size;
    },
    // 下载模板
    downLoadFile() {
      const url = '/static/大件SKU导入模板.xlsx';
      saveAs(url, '大件SKU导入模板.xlsx');
    },
    // 点击确定
    cusSubmit(val) {
      if (val === 1) {
        this.exportDialog = false;
      } else {
        const formData = new FormData();
        formData.append('customerId', this.customerId);
        // 如果有文件上传
        if (this.fileName) {
          formData.append('sizeFile', this.sizeFile);
          formData.append('file', this.fileData, this.fileName);
          formData.append('fileName', this.fileName);
        } else {
          this.$message.error(this.$t('routes.pleaseUploadFile'));
          return;
        }
        customerSkuInfoImport(formData).then((res) => {
          if (res.code === 200) {
            this.exportDialog = false;
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            this.queryForm.pageNumber = 1;
            this.getSearch();
            this.handleClose();
          }
        });
      }
    },
    handleClose() {
      this.fileName = '';
      this.fileData = null;
      this.sizeFile = '';
      this.fileList = [];
    },
    editSku(row) {
      this.editId = row.id;
      console.log(row, 'editSku');
      this.skuListAdd = [];
      this.newFormInline.skuList = [...this.recordsList];
      this.newFormInline.skuList.map((item) => {
        if (item.id === row.id) {
          item.isEdit = true;
        } else {
          item.isEdit = false;
        }
      });
    },
    resetForm() {
      this.skuListAdd = [];
      this.newFormInline.skuList = [...this.skuListAdd, ...this.recordsList];
    },
    delSku(row) {
      console.log(row);
      const index = this.skuListAdd.findIndex((item) => item.deleteFlag === row.deleteFlag);
      console.log(index, 'index');
      if (index !== -1) {
        this.skuListAdd.splice(index, 1);
      }
      this.newFormInline.skuList = [...this.skuListAdd, ...this.recordsList];
    },
    saveOneSku(scope, id) {
      console.log(scope, 'saveOneSku');
      this.$refs['addFormRef'].validate((valid) => {
        if (valid) {
          const data = {
            id,
            productName: scope.row.productName, // 产品名称
            skuCode: scope.row.skuCode, // 产品SKU代码
            dimension: scope.row.dimension, // 外观尺寸(m³)
            grossWeight: scope.row.grossWeight, // 毛重(KG)
            status: scope.row.status // 状态 0-停用、1-启用
          };
          customerSkuInfoEdit(data).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.newFormInline.skuList[scope.$index].isEdit = false;
              this.getSearch();
            }
          });
        }
      });
    },
    cancelSku(scope) {
      console.log(scope.$index, 'scope.$index');
      this.newFormInline.skuList[scope.$index].isEdit = false;
    },
    clickAddData() {
      this.skuListAdd.unshift({
        deleteFlag: this.deleteFlag++,
        isEdit: true,
        isEditNew: false,
        isDel: true,
        productName: '', // 产品名称
        skuCode: '', // 产品SKU代码
        dimension: '', // 外观尺寸(m³)
        grossWeight: '', // 毛重(KG)
        status: 1 // 状态 0-停用、1-启用
      });
      this.newFormInline.skuList = [...this.skuListAdd, ...this.recordsList];
    },
    // 提交
    clickSubmit() {
      this.$refs['addFormRef'].validate((valid) => {
        if (valid) {
          const data = {
            customerId: this.customerId,
            skuList: []
          };
          let arr = [];
          if (this.skuListAdd.length > 0) {
            const checked = [];
            // 遍历数组，发现重复立即返回true
            const isDuplicate = this.skuListAdd.some((item) => {
              const sku = item.skuCode;
              // 检查当前sku是否已出现过
              if (checked.includes(sku)) {
                // 重复，报错并退出
                console.error(`错误：skuCode "${sku}" 不能重复`);
                return true; // 触发some()返回true，终止遍历
              }
              checked.push(sku);
              return false;
            });
            console.log(isDuplicate, 'isDuplicateisDuplicate');
            if (isDuplicate) {
              this.$message.error(this.$t('uploadFile.productSkuCodeUnique'));
              return;
            }
            const length = this.skuListAdd.length;
            arr = this.newFormInline.skuList.slice(0, length);
          } else {
            return;
          }
          data.skuList = arr;
          customerSkuInfoAdd(data).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.skuListAdd = [];
              this.queryForm.pageNumber = 1;
              this.getSearch();
            }
          });
        }
      });
    },
    // 编辑
    clickSenderDialog() {
      this.exportDialog = true;
    },
    getSearch() {
      const data = {
        params: {}
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.pageNumber;
      data.params.customerId = this.customerId;
      customerSkuInfoPage(data).then((res) => {
        if (res.code === 200) {
          res.data.records.forEach((item) => {
            item.isEdit = false;
          });
          this.recordsList = res.data.records;
          this.newFormInline.skuList = [...this.skuListAdd, ...this.recordsList];
          this.queryForm.total = res.data.total;
        }
      });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__title {
  font-size: 16px;
  font-weight: bold;
}

.editOperation {
  color: #409eff;
  cursor: pointer;
}

.delOperation {
  color: #ff1135;
  cursor: pointer;
}

.cancalOperation {
  color: #009743;
  cursor: pointer;
}

.downLink {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
  cursor: pointer;
  padding: 5px;
}

.downModule {
  color: #409eff;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 15px;
  background-color: #f5f7fa;
  padding: 5px;
}

.uploadArea {
  text-align: center;
  background-color: #f2f3f5;
  padding: 20px 0;
  width: 70%;
  margin: 10px auto;
  cursor: pointer;
}
</style>
